import Action from '../base';
import { getCurrentElement, getElementValue, getElementsByField } from '../util';
import Element from '../../../geometry/element/';
import { deepMix, each, isFunction } from '@antv/util';
import { LooseObject } from '../../../interface';
import { IGroup, ShapeAttrs } from '../../../dependents';

type LinkActiveStyle = ShapeAttrs | ((style: ShapeAttrs, Element: Element) => ShapeAttrs);

/**
 * Link Elements by color
 *
 * public æ¹æ³æ¯å¯¹å¤å¯ç¨çåé¦äº¤äºãä½¿ç¨æ¹å¼ï¼å¦ï¼element-link-by-color:link, element-link-by-color:unlink, element-link-by-color:clear
 */
class LinkByColor extends Action {
  private linkGroup: IGroup;
  private cache: LooseObject = {};
  // è·åé¢è²å¯¹åºç scale
  private getColorScale(view, element) {
    const colorAttr = element.geometry.getAttribute('color');
    if (!colorAttr) {
      return null;
    }
    const scale = view.getScaleByField(colorAttr.getFields()[0]);
    return scale;
  }
  // è·åè¿æ¥ç path
  private getLinkPath(element: Element, nextElement: Element) {
    const view = this.context.view;
    const { isTransposed } = view.getCoordinate();
    const bbox = element.shape.getCanvasBBox();
    const nextBBox = nextElement.shape.getCanvasBBox();
    const path = isTransposed
      ? [
          ['M', bbox.minX, bbox.minY],
          ['L', nextBBox.minX, nextBBox.maxY],
          ['L', nextBBox.maxX, nextBBox.maxY],
          ['L', bbox.maxX, bbox.minY],
          ['Z'],
        ]
      : [
          ['M', bbox.maxX, bbox.minY],
          ['L', nextBBox.minX, nextBBox.minY],
          ['L', nextBBox.minX, nextBBox.maxY],
          ['L', bbox.maxX, bbox.maxY],
          ['Z'],
        ];
    return path;
  }
  // æ·»å è¿æ¥çå¾å½¢
  private addLinkShape(group: IGroup, element: Element, nextElement: Element, activeStyle?: LinkActiveStyle) {
    const style = {
      opacity: 0.4,
      fill: element.shape.attr('fill'),
    };
    group.addShape({
      type: 'path',
      attrs: {
        ...deepMix({}, style, isFunction(activeStyle) ? activeStyle(style, element) : activeStyle),
        path: this.getLinkPath(element, nextElement),
      },
    });
  }
  // ä½¿ç¨å¾å½¢è¿æ¥
  private linkByElement(element: Element, activeStyle?: LinkActiveStyle) {
    const view = this.context.view;
    const scale = this.getColorScale(view, element);
    if (!scale) {
      return;
    }
    const value = getElementValue(element, scale.field);
    if (!this.cache[value]) {
      const elements = getElementsByField(view, scale.field, value);
      const linkGroup = this.linkGroup;
      const group = linkGroup.addGroup();
      this.cache[value] = group; // ç¼å­
      const count = elements.length;
      each(elements, (el, index) => {
        if (index < count - 1) {
          const nextEl = elements[index + 1];
          this.addLinkShape(group, el, nextEl, activeStyle);
        }
      });
    }
  }
  // ç§»é¤è¿æ¥
  private removeLink(element) {
    const scale = this.getColorScale(this.context.view, element);
    if (!scale) {
      return;
    }
    const value = getElementValue(element, scale.field);
    if (this.cache[value]) {
      this.cache[value].remove();
      this.cache[value] = null;
    }
  }

  /**
   * è¿æ¥ elements
   *
   * @usage
   * registerInteraction('xxx', {
   *   start: [
   *    {
   *      trigger: 'interval:mouseenter',
   *      action: 'element-link-by-color:link',
   *      arg: {
   *        // style: { fill: 'red' }
   *        style: (style, element) => ({ fill: 'red' })
   *     },
   *   },
   *  ],
   * });
   */
  public link(args?: { style: LinkActiveStyle }) {
    const context = this.context;
    if (!this.linkGroup) {
      // ä¸åè®¸è¢«æ¾å
      this.linkGroup = context.view.foregroundGroup.addGroup({
        id: 'link-by-color-group',
        capture: false,
      });
    }
    const element = getCurrentElement(context);
    if (element) {
      this.linkByElement(element, args?.style);
    }
  }

  /**
   * åæ¶è¿æ¥ elements
   */
  public unlink() {
    const element = getCurrentElement(this.context);
    if (element) {
      this.removeLink(element);
    }
  }

  /**
   * æ¸é¤ææè¿æ¥
   */
  public clear() {
    if (this.linkGroup) {
      this.linkGroup.clear();
    }
    this.cache = {};
  }

  /**
   * éæ¯
   */
  destroy() {
    super.destroy();
    if (this.linkGroup) {
      this.linkGroup.remove();
    }
  }
}
export default LinkByColor;
